import { createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/キラキラ.png'
import _imports_1 from '@/assets/img/logo.png'
import _imports_2 from '@/assets/img/app_download.png'
import _imports_3 from '@/assets/img/google_play_download.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-60bc3afb")

_pushScopeId("data-v-60bc3afb")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "modal-content" }, [
  /*#__PURE__*/_createVNode("div", { class: "top-logo" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "kira",
      src: _imports_0
    }),
    /*#__PURE__*/_createVNode("img", {
      class: "modal-icon",
      src: _imports_1
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "txt txt-download" }, "アプリをダウンロードしよう！"),
  /*#__PURE__*/_createVNode("p", { class: "txt txt-notice" }, [
    /*#__PURE__*/_createTextVNode("アプリをダウンロードして"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("通知を受け取ろう")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "download-icons" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "https://apps.apple.com/jp/app/onlylive/id1554615532",
      target: "_blank"
    }, [
      /*#__PURE__*/_createVNode("img", {
        class: "download-icon",
        alt: "Apple Store で手に入れよう",
        src: _imports_2
      })
    ]),
    /*#__PURE__*/_createVNode("a", {
      href: "https://play.google.com/store/apps/details?id=com.ILEO.onlylive&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
      target: "_blank"
    }, [
      /*#__PURE__*/_createVNode("img", {
        class: "download-icon",
        alt: "Google Play で手に入れよう",
        src: _imports_3
      })
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withId(() => [
      _createVNode("div", {
        class: "modal modal-overlay",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _hoisted_1
      ])
    ]),
    _: 1
  }))
})